module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.Connect2-e1c2d16c83c8aa745a10ea60b7ca12b2.jpg";